module.exports = __webpack_public_path__ + "img/lamp-slash.ad5d4776.svg";